import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { PublicClientApplication } from "@azure/msal-browser";
import axios from '../../axios'

class AzureModal extends Component {
    constructor(props) {
        super(props);
        this.pca = null;
    }

    handleLogin = async () => {
        let response  = await axios.get('/api/company/getAzureSettings')
        let companyClientId = process.env.REACT_APP_ClientID;
        let clientId = response.data.result?.clientId;
        let groups = response.data.result?.groups;
        let azureGroupEnabled = response.data.result?.azureGroupEnabled;
        const msalConfig = {
            auth: {
                clientId: clientId? clientId: companyClientId
            },
        };
        
        const loginRequest = {
            scopes: ["User.Read", "User.Read.All", "Group.Read.All"]
        };
        
        // Manually clear interaction state for independent popups
        sessionStorage.removeItem("msal.interaction.status");
    
        // Create a new instance of PublicClientApplication
        const pcaInstance = new PublicClientApplication(msalConfig);

        try {
            const loginResponse = await pcaInstance.loginPopup(loginRequest);
            if (loginResponse) {
                //Now we get an accessToken
                let msalResponse = await pcaInstance.acquireTokenSilent({
                    ...loginRequest,
                    account: pcaInstance.getAccountByHomeId(loginResponse.account.homeAccountId)
                });
                if(msalResponse){
                    if(azureGroupEnabled){
                        msalResponse = JSON.parse(JSON.stringify(msalResponse));
                        msalResponse = {...msalResponse, groups}
                    }
                    this.props.responseAzure(null, msalResponse);
                }
            }
        } catch (err) {
            this.props.responseAzure(err, null);
        }
    }

    render() {
        return (
            <Modal
                show={this.props.show}
                onHide={this.props.showHandle}
                dialogClassName="modal-90w"
                aria-labelledby="example-custom-modal-styling-title">
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        <h6 className="mb-0">Import from Azure</h6>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="noteSection">
                        <p><b>Note:</b> Your remaining user limit is {this.props.remainingUsersLimit}. Ensure your Azure Admin account has no more than {this.props.remainingUsersLimit} unique users; otherwise, only the first {this.props.remainingUsersLimit} unique users will be uploaded.</p>
                    </div>
                    <p>
                        Import all users associated with your Azure admin account by logging into the account through
                        the button given below.
                    </p>
                    <div className="text-center">
                        <Button variant="primary" onClick={this.handleLogin}>
                            Sign up using Azure
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}

export default AzureModal;
